<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Set Runtime Conditions</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Name ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Name</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="name" [(ngModel)]="name" required>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Runtime Conditions</label>
                        </div>
                    </div>

                    <div class="row m-b-md" *ngFor="let c of conditions; let index = index;">
                        <div class="col-md-4">
                            {{getKeyName(c.key)}}
                        </div>
                        <div class="col-md-4">
                            <select class="form-control"
                                    name="condition{{index}}"
                                    [(ngModel)]="c.condition"
                                    (change)="onConditionChange($event, c)">
                                <option value="" hidden></option>
                                <option *ngFor="let cond of getConditions(c.key)" [value]="cond.id">
                                    {{cond.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4 directory-add-modal-date-field"
                             *ngIf="c.inputType"
                             [ngClass]="{'report-generator-multiselect': c.inputType == 'buildings' || c.inputType == 'possibleValues'}">
                            <input *ngIf="c.inputType == 'string'"
                                   class="form-control"
                                   name="value{{index}}"
                                   [(ngModel)]="c.values[0]">
                            <mat-form-field *ngIf="c.inputType == 'date'">
                                <input matInput
                                       [(ngModel)]="c.values[0]"
                                       name="value{{index}}"
                                       [matDatepicker]="datePicker"
                                       (focus)="datePicker.open()"
                                       (click)="datePicker.open()"
                                       placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                                <mat-datepicker #datePicker></mat-datepicker>
                            </mat-form-field>
                            <multiselect-field *ngIf="c.inputType == 'buildings'"
                                               name="value{{index}}"
                                               [editOnly]="true"
                                               [data]="reportGeneratorService.buildingsForMultiselect"
                                               [(ngModel)]="c.values">
                            </multiselect-field>
                            <multiselect-field *ngIf="c.inputType == 'possibleValues'"
                                               name="value{{index}}"
                                               [editOnly]="true"
                                               [data]="c.possibleValues"
                                               [blankError]="'Values should not be blank.'"
                                               [(ngModel)]="c.values">
                            </multiselect-field>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Run</button>
                    </div>

                </div>
            </div>
            <spinner [spinnerShow]="showSpinner"></spinner>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/runtime-conditions-modal/runtime-conditions-modal.component.html